export const GET_ENGAGEMENT_DATA = "GET_ENGAGEMENT_DATA"
export const GET_ENGAGEMENT_DATA_SUCCESS = "GET_ENGAGEMENT_DATA_SUCCESS"
export const GET_ENGAGEMENT_DATA_FAILURE = "GET_ENGAGEMENT_DATA_FAILURE"

export const POST_TIMETRACKER_DATA = "POST_TIMETRACKER_DATA"
export const POST_TIMETRACKER_DATA_SUCCESS = "POST_TIMETRACKER_DATA_SUCCESS"
export const POST_TIMETRACKER_DATA_FAILURE = "POST_TIMETRACKER_DATA_FAILURE"
